import { useEffect, useState } from 'react';

import { LmBadgeStatus, LmButton, LmText, LmTooltip, useOnMouseEnter } from '@mes-ui/lemma';
import { LmIconFilledChevronsSmallDown, LmIconFilledChevronsSmallUp } from '@mes-ui/lemma/icons';
import { Box, Stack, useMediaQuery } from '@mui/material';
import Carousel from 'components/common/Carousel';
import WidgetCard from 'components/redesignStudent/widgets/WidgetCard';
import { useAppDispatch, useAppSelector } from 'hooks';
import FixedWidthContainer from 'portfolio3/components/common/FixedWidthContainer';
import { emitYMEvent } from 'portfolio3/features/yandexMetrika';
import { commonTheme } from 'portfolio3/styles/theme';
import { Slide, Slider } from 'pure-react-carousel';
import {
  configSelector,
  currentStudentMeshIdSelector,
  widgetsDataLoadingSelector,
  widgetsDataSelector,
} from 'selectors';
import { widgetsActions } from 'slices';

import './index.scss';

const CARD_WIDTH = 347;
const MOBILE_CARD_WIDTH = 297;
const CARD_GAP = 16;
const MOBILE_CARD_GAP = 12;

const WidgetsContainer = () => {
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery(commonTheme.breakpoints.down('commonSm'));
  const config = useAppSelector(configSelector);
  const [isOpen, setIsOpen] = useState(true);

  const widgetsData = useAppSelector(widgetsDataSelector);
  const loading = useAppSelector(widgetsDataLoadingSelector);
  const meshId = useAppSelector(currentStudentMeshIdSelector);

  const { isMouseEnter, handleMouseLeave, handleMouseEnter } = useOnMouseEnter();
  const hideWidgets = !config || config.HIDE_WIDGETS === true;

  const handleExpand = () => {
    setIsOpen(!isOpen);
    emitYMEvent({
      type: 'portfolio_widgets_collapseOrExpand_click',
      payload: {
        buttonType: isOpen ? 'collapse' : 'expand',
      },
    });
  };

  useEffect(() => {
    if (meshId && !hideWidgets) {
      dispatch(widgetsActions.request({ personId: meshId }));
    }
  }, [meshId, hideWidgets]);

  if (loading || widgetsData.length === 0 || hideWidgets) {
    return null;
  }

  return (
    <FixedWidthContainer>
      <Stack spacing={1.5} className="widgets-container">
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Stack direction="row" spacing={1.5}>
            <LmText variant="h6">Последние обновления</LmText>
            <LmTooltip
              open={isMouseEnter}
              placement="right"
              content="Достижения, добавленные в Портфолио автоматически или сотрудниками школы, за последние 30 дней"
              withArrow
            >
              <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                <LmBadgeStatus color="violet" colorStyle="full">
                  Новое
                </LmBadgeStatus>
              </div>
            </LmTooltip>
          </Stack>
          <LmButton onClick={handleExpand} variant="link">
            <>
              {!isMobile ? `${isOpen ? 'Свернуть' : 'Развернуть'}` : null}
              {isOpen ? (
                <LmIconFilledChevronsSmallUp style={{ width: 20, height: 20 }} />
              ) : (
                <LmIconFilledChevronsSmallDown style={{ width: 20, height: 20 }} />
              )}
            </>
          </LmButton>
        </Box>
        {isOpen && (
          <div className="widgets-carousel">
            <Carousel
              items={widgetsData}
              cardWidth={isMobile ? MOBILE_CARD_WIDTH : CARD_WIDTH}
              gap={isMobile ? MOBILE_CARD_GAP : CARD_GAP}
            >
              <Slider>
                {widgetsData.map((item, index) => (
                  <Slide key={`${item.blockName}-${index}`} index={index} className="slide">
                    <WidgetCard widgetData={item} />
                  </Slide>
                ))}
              </Slider>
            </Carousel>
          </div>
        )}
      </Stack>
    </FixedWidthContainer>
  );
};

export default WidgetsContainer;
